import { render, staticRenderFns } from "./MinistryReports.vue?vue&type=template&id=9ccaeb84&scoped=true"
import script from "./MinistryReports.vue?vue&type=script&lang=js"
export * from "./MinistryReports.vue?vue&type=script&lang=js"
import style0 from "./MinistryReports.vue?vue&type=style&index=0&id=9ccaeb84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccaeb84",
  null
  
)

export default component.exports